import React from 'react';
import { Modal, Button } from 'react-bootstrap'

class ErrorDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = { visible: props.visible };
    }

    componentWillReceiveProps(props, nextProps) {
        this.setState({ visible: props.visible });
    }

    close = () => {
        this.setState({ visible: false }, () => this.props.onClose()
        );
    }

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}>
                <Modal.Header>
                    <Modal.Title>Ooops! There seems to be an issue...</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>There is an existing Company with this FEIN/EIN and/or Company Name within our Database...</p>
                    <p>Please double-check your Company FEIN/EIN and Company Name for any error(s).</p>
                    <p>If you believe this to be a mistake, please don't hesitate to email us at VOCS Certification: <a href="mailto:certification@nvbdc.org">certification@NVBDC.org</a></p>

                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary" onClick={this.close}>Continue</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ErrorDialog;



// WEBPACK FOOTER //
// ./src/areas/companyManagement/certifyBusiness/ErrorDialog.js